import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { Notification } from '@beef/ui-kit';
import { resetAddressAndScrollInto } from "../../../../store/blocks/tariffs/resetAddressAndScrollInto";
import { getAddressNotificationText, getNotificationButtonText, getNotificationVariant } from "../../../../store/blocks/tariffs/selectors";
import { selectShowNotificationFlag } from "../../../../store/blocks/addressVerification/moduleSelectors";
var _AddressNotification = function _AddressNotification(_ref) {
  var buttonText = _ref.buttonText,
    className = _ref.className,
    onClick = _ref.onClick,
    text = _ref.text,
    variant = _ref.variant;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "components-AddressNotification"
  }, /*#__PURE__*/React.createElement(Notification, {
    buttonText: buttonText,
    onClick: onClick,
    text: text,
    variant: variant
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  var text = getAddressNotificationText(state);
  return {
    buttonText: getNotificationButtonText(state),
    shouldRender: text && selectShowNotificationFlag(state),
    text: text,
    variant: getNotificationVariant(state)
  };
};
var mapDispatchToProps = {
  onClick: resetAddressAndScrollInto
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var AddressNotification = compose(connector, withRenderFlag)(_AddressNotification);